export default __webpack_public_path__ + "static/media/adultLogo.4839407f.png";